// src/services/deportistasService.js
import { getAuthHeader } from "./authService";

export const INSTITUCION_ID = "16020324-f0ea-4319-905c-5a30618ce9f5";

const BASE_URL = `${(process.env.REACT_APP_BACKEND_URL || "http://localhost:3000").replace(
  /\/$/,
  ""
)}/api/v1/deportistas`;

const AUTH_URL = `${BASE_URL}/autorizar`;

const toJson = (res) =>
  res
    .json()
    .catch(() => ({}));

const ensureOk = (res, data) => {
  if (!res.ok) {
    console.error("[DEP][ERROR] Request falló:", res.status, data);
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};

export async function listDeportistas() {
  const url = `${BASE_URL}/${INSTITUCION_ID}`;

  const res = await fetch(url, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  ensureOk(res, data);
  const salida = Array.isArray(data) ? data : data?.data ?? [];

  return salida;
}

export async function updateDeportista(form) {
  if (!form.id) {
    throw new Error("ID del deportista es requerido para actualizar");
  }

  // Crear FormData en lugar de JSON
  const formData = new FormData();

  const fields = {
    posicion_id: form.posicion_id,
    grupo_id: form.grupo_id,
    nombres: form.nombres,
    apellidos: form.apellidos,
    direccion: form.direccion,
    telefono: form.telefono,
    email: form.email,
    observaciones: form.observaciones,
    foto_url: form.foto_url,
    cedula_scan_url: form.cedula_scan_url,
  };

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (value === "" && (key === "foto_url" || key === "cedula_scan_url")) {
        formData.append(key, "");
      } else if (value !== "") {
        // Si no es string vacío, agregarlo normalmente
        formData.append(key, value);
      }
    }
  });

  const url = `${BASE_URL}/${form.id}`;

  const headers = {
    Accept: "application/json",
    ...getAuthHeader(),
  };

  const res = await fetch(url, {
    method: "PUT",
    headers: headers,
    body: formData, // Enviar FormData en lugar de JSON
  });

  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

export async function authorizeDeportista({
  id,
  autorizado_dep,
  observacion_ced_fot,
}) {
  if (!id) throw new Error("ID del deportista es requerido para autorizar");

  const payload = {
    autorizado_dep,
    observacion_ced_fot: observacion_ced_fot ?? "",
  };

  const url = `${AUTH_URL}/${id}`;

  const res = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}